import { ForgeIterationMessage } from "@supernova-studio/model";
import { z } from "zod";
import { DTOForgeParticipant } from "./participant";

export const DTOForgeIterationMessage = ForgeIterationMessage.omit({ participant: true }).extend({
  participant: DTOForgeParticipant,
});

export const DTOCreateForgeIterationMessage = DTOForgeIterationMessage.omit({
  projectIterationId: true,
  participant: true,
});

export const DTOGetForgeIterationMessageResponse = z.object({
  message: DTOForgeIterationMessage.nullable(),
});

export const DTOForgeIterationMessagesListResponse = z.object({
  messages: z.array(DTOForgeIterationMessage),
});

export const DTOUpdateForgeIterationMessage = DTOCreateForgeIterationMessage.extend({ id: z.string() });

export const DTOCreateForgeIterationMessageResponse = z.object({
  message: DTOForgeIterationMessage,
});

export const DTOUpdateForgeIterationMessageResponse = z.object({
  message: DTOForgeIterationMessage.nullable(),
});

export const DTODeleteForgeIterationMessageResponse = z.object({
  ok: z.literal(true),
});

export type DTOForgeIterationMessage = z.infer<typeof DTOForgeIterationMessage>;
export type DTOGetForgeIterationMessageResponse = z.infer<typeof DTOGetForgeIterationMessageResponse>;
export type DTOForgeIterationMessagesListResponse = z.infer<typeof DTOForgeIterationMessagesListResponse>;
export type DTOCreateForgeIterationMessage = z.infer<typeof DTOCreateForgeIterationMessage>;
export type DTOUpdateForgeIterationMessage = z.infer<typeof DTOUpdateForgeIterationMessage>;
export type DTOCreateForgeIterationMessageResponse = z.infer<typeof DTOCreateForgeIterationMessageResponse>;
export type DTOUpdateForgeIterationMessageResponse = z.infer<typeof DTOUpdateForgeIterationMessageResponse>;
export type DTODeleteForgeIterationMessageResponse = z.infer<typeof DTODeleteForgeIterationMessageResponse>;
